import React from 'react';

const Terms = () => {
  return (
    <div className="min-h-screen pt-32 md:pt-36">
      <section className="py-16 md:py-24">
        <div className="container">
          <div className="max-w-4xl mx-auto">
            <h1 className="display-large mb-8">Terms of Service</h1>
            <div className="space-y-6 body-medium">
              <p className="body-large text-[#0C6951]">Effective Date: October 17, 2024

              </p>

              <div>
                <h2 className="heading-2 mb-4">1. Acceptance</h2>
                <p>
                  By accessing FITNOVEXA services, you agree to these Terms. If you disagree, please do not use our services.
                </p>
              </div>

              <div>
                <h2 className="heading-2 mb-4">2. Services</h2>
                <p>
                  FITNOVEXA provides fitness technology consulting, online education, and related services. 
                  We reserve the right to modify or discontinue services at any time.
                </p>
              </div>

              <div>
                <h2 className="heading-2 mb-4">3. User Obligations</h2>
                <p className="mb-3">You agree to:</p>
                <ul className="list-disc pl-6 space-y-2">
                  <li>Provide accurate information</li>
                  <li>Maintain account security</li>
                  <li>Use services lawfully</li>
                  <li>Not interfere with service operations</li>
                </ul>
              </div>

              <div>
                <h2 className="heading-2 mb-4">4. Intellectual Property</h2>
                <p>
                  All content and materials are owned by FITNOVEXA and protected by copyright and trademark laws. 
                  Unauthorized use is prohibited.
                </p>
              </div>

              <div>
                <h2 className="heading-2 mb-4">5. Limitation of Liability</h2>
                <p>
                  FITNOVEXA is not liable for indirect, incidental, or consequential damages arising from 
                  service use. Services are provided "as is" without warranties.
                </p>
              </div>

              <div>
                <h2 className="heading-2 mb-4">6. Contact</h2>
                <p>
                  Questions about these Terms? Contact us at:<br />
                  Email: info@fitnovexa.com<br />
                  Website: fitnovexa.com
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>);

};

export default Terms;